"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._AllowedMethods = {
    type: "list",
    flattened: true,
    member: {
        shape: {
            type: "string"
        }
    }
};
//# sourceMappingURL=_AllowedMethods.js.map